import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequiredRolesDirective } from './required-roles.directive';

@NgModule({
  declarations: [RequiredRolesDirective],
  imports: [CommonModule],
  exports: [RequiredRolesDirective],
})
export class RequiredRolesModule {}
